var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page" }, [
    _c("div", { staticClass: "saas-hero card-saas" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/blog" } }, [
              _vm._v(_vm._s(_vm.trans("blog.blog"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("blog.edit_post")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("blog.edit_post"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-saas mt-3" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [_c("blog-form", { attrs: { id: _vm.id } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }